module.exports = __webpack_public_path__ + "static/media/logo.004d4b8e.png";